import { AxiosInstance } from 'axios';
import { ApplogEndpoint } from '../../../@constants/ApiEndpoints';

export const getAll =
  (axios: AxiosInstance) =>
  async (params: {
    subject_type: 'reservation_room';
    subject_id: number;
    search?: string;
    limit: number;
    offset: number;
    date_from?: string;
    date_to?: string;
    action?: string;
    user_id?: string;
  }): Promise<{
    items: {
      id: number;
      action: string;
      business_action: string | null;
      description: string;
      field: string;
      old_value: string;
      new_value: string;
      user: string;
      date: string;
    }[];
    total: number;
  }> => {
    return await axios
      .get(ApplogEndpoint.APPLOG_USER_LOG_GET, {
        params,
      })
      .then(({ data }) => data);
  };

export const getAllBusinessActions =
  (axios: AxiosInstance) => async (): Promise<{ items: Array<string> }> => {
    return await axios
      .get(ApplogEndpoint.APPLOG_USER_LOG_GET_BUSINESS_ACTIONS)
      .then(({ data }) => data);
  };
